<!--
 * @Author: Mr.Cong Wei
 * @Date: 2022-12-12 16:58:48
 * @LastEditTime: 2022-12-12 17:11:05
-->
<template>
  <div style="position: relative; width: 20px; height: 20px">
    <svg
      version="1.1"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="20px"
      height="20px"
      xmlns="http://www.w3.org/2000/svg"
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
    >
      <g transform="matrix(1 0 0 1 -546 -420 )">
        <path
          d="M 556 420  C 561.6 420  566 424.4  566 430  C 566 435.6  561.6 440  556 440  C 550.4 440  546 435.6  546 430  C 546 424.4  550.4 420  556 420  Z "
          fill-rule="nonzero"
          fill="#b282ea"
          stroke="none"
        />
        <path
          d="M 556 420.5  C 561.32 420.5  565.5 424.68  565.5 430  C 565.5 435.32  561.32 439.5  556 439.5  C 550.68 439.5  546.5 435.32  546.5 430  C 546.5 424.68  550.68 420.5  556 420.5  Z "
          stroke-width="1"
          stroke="#ffffff"
          fill="none"
        />
      </g>
    </svg>
    <span
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      style="color: #fff"
    >
      研
    </span>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
